// extracted by mini-css-extract-plugin
export default {"section":"RestrictedActionModal-module__section___Sn0Dx","sectionTitle":"RestrictedActionModal-module__sectionTitle___HO2ej"};